import { render, staticRenderFns } from "./ContractorsCard.vue?vue&type=template&id=623fe544&"
import script from "./ContractorsCard.vue?vue&type=script&lang=js&"
export * from "./ContractorsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports